import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IPromoModalInformationResponse } from "@faire/web-api--source/indigofair/data/IPromoModalInformationResponse";
export var getPromoModalInformation = function() {
    var _getGlobalProperty;
    return (_getGlobalProperty = getGlobalProperty("promoModalInformation")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : IPromoModalInformationResponse.build({
        type: "NONE"
    });
};
